import * as THREE from 'three';
import { ball, mesh, tube } from './art';

export class CanalAnimals {
  readonly group = new THREE.Group();
  private ducks: THREE.Group[] = [];
  private snail = new THREE.Group();
  private sparrow = new THREE.Group();
  private wings: THREE.Object3D[] = [];
  constructor(parent: THREE.Group) {
    parent.add(this.group);
    for (let i = 0; i < 4; i++) {
      const duck = new THREE.Group(); this.group.add(duck); this.ducks.push(duck);
      duck.name = i ? 'canal-duckling' : 'canal-duck'; duck.scale.setScalar(i ? .38 : 1);
      ball(duck, 0, .8, 0, 1.5, .8, .85, i ? '#e5cc79' : '#c7b7a1');
      ball(duck, .9, 1.65, 0, .6, .65, .5, i ? '#ead68e' : '#527e68');
      ball(duck, 1.55, 1.5, 0, .45, .12, .24, '#d9a15e');
      for (const side of [-1, 1]) ball(duck, 1.15, 1.85, side * .4, .08, .08, .06, '#354844');
      ball(duck, -.3, .95, .65, .9, .35, .2, i ? '#d7b764' : '#8d9b98');
    }
    this.snail.name = 'canal-snail'; this.group.add(this.snail);
    ball(this.snail, 0, .24, 0, 1.6, .24, .45, '#a4ad81');
    ball(this.snail, -.3, .95, 0, .85, .85, .6, '#c59b7c');
    mesh(new THREE.TorusGeometry(.5, .09, 8, 24), '#927768', this.snail, -.3, 1, .55);
    for (const side of [-1, 1]) {
      tube(this.snail, [new THREE.Vector3(1, .3, side * .2), new THREE.Vector3(1.3, 1, side * .3)], .055, '#a4ad81');
      ball(this.snail, 1.3, 1, side * .3, .1, .1, .1, '#354844');
    }
    this.sparrow.name = 'canal-sparrow'; this.group.add(this.sparrow);
    ball(this.sparrow, 0, 1.1, 0, 1, .9, .6, '#a78c79');
    ball(this.sparrow, .7, 1.9, 0, .6, .6, .5, '#c1a98c');
    ball(this.sparrow, 1.3, 1.8, 0, .3, .12, .14, '#8c7961');
    for (const side of [-1, 1]) {
      ball(this.sparrow, .9, 2.05, side * .43, .09, .09, .06, '#354844');
      this.wings.push(ball(this.sparrow, -.2, 1.25, side * .55, .8, .35, .15, '#776b62'));
      tube(this.sparrow, [new THREE.Vector3(0, .1, side * .25), new THREE.Vector3(0, .7, side * .25)], .06, '#8c7961');
    }
    ball(this.sparrow, -1, 1, 0, .8, .2, .3, '#776b62');
  }
  animate(time: number, x: number, z: number): void {
    this.group.visible = x > 120 && z < -45;
    this.ducks.forEach((duck, i) => {
      const t = time * .22 - i * .32;
      duck.position.set(286 + Math.sin(t) * 5, .1 + Math.sin(time * 1.6 - i) * .035, -120 + Math.sin(t * 2) * 1.1);
      duck.rotation.y = Math.atan2(-2.2 * Math.cos(t * 2), 5 * Math.cos(t));
      duck.visible = Math.hypot(x - duck.position.x, z - duck.position.z) < 80;
    });
    const creep = Math.max(0, Math.sin(time * .08));
    this.snail.position.set(198 + creep * 2, .02, -154);
    this.snail.visible = Math.hypot(x - 198, z + 154) < 70;
    const phase = time % 18; const flutter = phase > 14;
    this.sparrow.position.set(444 + Math.sin(time * .4) * 1.2, flutter ? Math.sin((phase - 14) / 4 * Math.PI) * 3 : Math.max(0, Math.sin(time * 4)) * .15, -80);
    this.sparrow.rotation.z = !flutter && phase % 5 < 1 ? -.35 : 0;
    this.wings.forEach((wing, i) => wing.rotation.x = flutter ? Math.sin(time * 18) * .8 * (i ? 1 : -1) : 0);
    this.sparrow.visible = Math.hypot(x - 444, z + 80) < 70;
  }
}
